import React from "react";
import { InfoBoxProps } from "../types";
import Image from "next/image";

function IconImage({ icon, heading }: InfoBoxProps) {
  if (!icon) return null;
  return (
    <div className="pb-0 md:pb-0 w-[15%] h-full flex justify-center items-center my-auto">
      <Image
        src={icon}
        alt={heading || ""}
        width={75}
        height={75}
        className="mx-auto"
      />
    </div>
  );
}

export default function DirectionalInfoBox({
  icon,
  heading,
  orientation = "icon-first",
  children,
}: InfoBoxProps) {
  const textAlignment = orientation == "icon-first" ? "text-start" : "text-end";
  return (
    <div className="bg-[#f2f0ef] container min-w-[75px] flex">
      {orientation === "icon-first" && (
        <IconImage icon={icon} heading={heading} />
      )}
      <ul
        className={
          "list-none flex-grow w-[85%] py-[20px] !px-[24px] align-middle " +
          textAlignment
        }
      >
        {heading && (
          <li className="font-semibold text-base leading-[26.64px]">
            {heading}
          </li>
        )}
        <li className="[&_*]:text-sm leading-[20.72px]">{children}</li>
      </ul>
      {orientation === "icon-last" && (
        <IconImage icon={icon} heading={heading} />
      )}
    </div>
  );
}
